import { fetchOnlaynZapisi, type OnlaynZapisUvedomlenie } from './onlaynApi';

export type OnlaynPoslanie =
  | { tip: 'novye'; zapisi: OnlaynZapisUvedomlenie[] }
  | { tip: 'pokazano'; ids: number[] };

export interface OnlaynSvyaz {
  skazat: (p: OnlaynPoslanie) => void;
  ostanovit: () => void;
}

const KANAL = 'opsmind-onlayn-zapisi-v1';
const ZAMOK_VEDUSHCHEY = 'opsmind-onlayn-zapisi-vedushchiy';
const zamki = (): LockManager | null => (typeof navigator !== 'undefined' && 'locks' in navigator ? navigator.locks : null);

function kursorIzPamyati(userId: number): number | null {
  try {
    const n = Number(window.localStorage.getItem(`opsmind.onlayn-uved.kursor.${userId}`));

    return Number.isInteger(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

function zapomnitKursor(userId: number, kursor: number): void {
  try {
    window.localStorage.setItem(`opsmind.onlayn-uved.kursor.${userId}`, String(kursor));
  } catch {
    // Без общей отметки следующая ведущая начнёт с текущего момента.
  }
}

/** Одна вкладка опрашивает ленту и раздаёт новые записи остальным. */
export function podklyuchitOnlayn(userId: number, onPoslanie: (p: OnlaynPoslanie) => void): OnlaynSvyaz {
  let zhiva = true;
  let taymer: number | undefined;
  let otpustitVedushchuyu: (() => void) | null = null;
  const kanal = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(`${KANAL}-${userId}`) : null;
  if (kanal !== null) kanal.onmessage = (e: MessageEvent<OnlaynPoslanie>) => { if (zhiva) onPoslanie(e.data); };

  const skazat = (p: OnlaynPoslanie) => {
    try { kanal?.postMessage(p); } catch { /* вкладка уже уходит */ }
  };

  const oprashivat = () => {
    let kursor = kursorIzPamyati(userId);
    const shag = async () => {
      if (!zhiva) return;
      let pauza: number;
      try {
        const otvet = await fetchOnlaynZapisi(kursor);
        if (!zhiva) return;
        kursor = otvet.kursor;
        zapomnitKursor(userId, kursor);
        pauza = Math.max(2, otvet.opros_sek ?? 5) * 1000;
        if (otvet.zapisi.length > 0) {
          const poslanie: OnlaynPoslanie = { tip: 'novye', zapisi: otvet.zapisi };
          skazat(poslanie);
          onPoslanie(poslanie);
        }
      } catch (e: unknown) {
        const status = (e as { response?: { status?: number } })?.response?.status;
        if (status === 401 || status === 403 || status === 404) return;
        pauza = 15_000;
      }
      taymer = window.setTimeout(() => void shag(), pauza);
    };
    void shag();
  };

  const z = zamki();
  if (z !== null && kanal !== null) {
    void z.request(`${ZAMOK_VEDUSHCHEY}-${userId}`, () => new Promise<void>((gotovo) => {
      if (!zhiva) { gotovo(); return; }
      otpustitVedushchuyu = gotovo;
      oprashivat();
    })).catch(() => {});
  } else {
    oprashivat();
  }

  return {
    skazat,
    ostanovit: () => {
      zhiva = false;
      if (taymer !== undefined) window.clearTimeout(taymer);
      otpustitVedushchuyu?.();
      kanal?.close();
    },
  };
}

/** Карточку одной записи показывает одна видимая вкладка. */
export async function vzyatOnlaynZapis(userId: number, id: number, derzhat: Promise<void>): Promise<boolean> {
  const z = zamki();
  if (z === null) return true;

  return new Promise<boolean>((otvet) => {
    void z.request(`opsmind-onlayn-zapis-${userId}-${id}`, { ifAvailable: true }, async (zamok) => {
      otvet(zamok !== null);
      if (zamok !== null) await derzhat;
    }).catch(() => otvet(true));
  });
}
